import { ActionIcon, Box, Text } from '@mantine/core'
import { Logo } from 'components/logo'

interface RegistrationHeaderProps {
  isSmallDevice: boolean
  currentLanguage: string
  onLanguageChange: () => void
}

export function RegistrationHeader({ isSmallDevice, currentLanguage, onLanguageChange }: RegistrationHeaderProps) {
  return (
    <Box
      component="header"
      sx={{
        background: '#fff',
        borderBottom: '1px solid #e5e7eb',
        position: 'sticky',
        top: 0,
        zIndex: 100,
      }}
    >
      <Box
        sx={{
          maxWidth: 1200,
          margin: '0 auto',
          padding: isSmallDevice ? '12px 16px' : '12px 32px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Logo width={120} />
        <ActionIcon
          variant="light"
          onClick={onLanguageChange}
          size={36}
          radius="md"
          sx={{
            fontWeight: 600,
            background: '#f3f4f6',
            '&:hover': { background: '#e5e7eb' },
          }}
        >
          <Text size="xs" weight={600}>
            {currentLanguage === 'fr' ? 'EN' : 'FR'}
          </Text>
        </ActionIcon>
      </Box>
    </Box>
  )
}
